<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>청약 입력/조회 및 증권출력</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>청약 입력/조회 및 증권출력</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>청약 입력/조회 및 증권출력</span>
          </button>
          <ul>
            <li>
              <router-link to="/contactpoint"
                ><span>알아두실 사항</span></router-link
              >
            </li>
            <li>
              <router-link to="/subsChangeForm"
                ><span>증권 간략 정정</span></router-link
              >
            </li>
            <li>
              <router-link to="/unpaidList"><span>미납조회</span></router-link>
            </li>
            <li>
              <router-link to="/staMon"><span>계약 통계</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="tabBtn" v-if="state.moveTypeCd != 'Y'">
          <router-link to="/sbcpInpInqNdPolOtpt" class="active"
            ><span>청약 입력</span></router-link
          >
          <router-link to="/subsRstList"
            ><span>청약 결과 조회</span></router-link
          >

          <router-link to="/getPolList"
            ><span>계약 조회 및 증권 출력</span></router-link
          >
        </div>

        <div class="sortWrap" v-if="state.moveTypeCd != 'Y'">
          <dl>
            <dt>조회구분</dt>
            <dd>
              <div class="split">
                <div class="inpSlt w265 mgr20">
                  <button type="button" class="sltBtn" title="조회구분 선택">
                    <span>가청약번호</span>
                  </button>
                  <ul>
                    <li v-for="(item, index) in state.stockBunho" :key="index">
                      <button
                        type="button"
                        class="sltOpt"
                        @click="onSelectEvent('subsInqDiv', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="inpTxt">
                  <input
                    type="text"
                    v-model="state.prctrNo"
                    v-show="state.subsInqDiv == '1'"
                    placeholder="가청약 번호를 입력하세요"
                    title="가청약 번호를 입력"
                  />
                  <input
                    type="text"
                    v-model="state.polNo"
                    v-show="state.subsInqDiv == '2'"
                    placeholder="진계약번호/참조번호를 입력하세요"
                    title="진계약번호/참조번호를 입력"
                  />
                </div>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="SearchFn(true)">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">조회결과</h3>

        <div class="tabStyle1">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="200" />
              <col width="400" />
              <col width="200" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">보험계약자</th>
                <td colspan="3">
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.n_ctoren"
                        title="보험계약자1"
                        disabled
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.n_ctorkr"
                        title="보험계약자2"
                        disabled
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">팀 분류코드</th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      class="sltBtn"
                      title="팀 분류코드 선택"
                      :disabled="state.sbcpCompTrgYn"
                    >
                      <span>선택</span>
                    </button>
                    <ul>
                      <li>
                        <button type="button" class="sltOpt" title="선택">
                          <span>선택</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">피보험자</th>
                <td colspan="3">
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.n_ctoren1"
                        title="피보험자1"
                      />
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.n_ctorkr1"
                        title="피보험자2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  참조번호1
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>L/C번호, INVOICE번호등 기입(최대 20 bytes)</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="참조번호1 선택"
                      >
                        <span id="refNo1">선택</span>
                      </button>
                      <ul>
                        <li
                          v-for="(item, index) in state.refNo1List"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            @click="onSelectEvent('refNo1', item)"
                          >
                            <span>{{ item.name }}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        placeholder="예시) INVOICE NO. PQC8678A"
                        v-model="state.refnNoCd1"
                        title="참조번호1"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  참조번호2
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>L/C번호, INVOICE번호등 기입(최대 20 bytes)</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="참조번호2 선택"
                      >
                        <span id="refNo2">선택</span>
                      </button>
                      <ul>
                        <li
                          v-for="(item, index) in state.refNo2List"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            @click="onSelectEvent('refNo2', item)"
                          >
                            <span>{{ item.name }}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        placeholder="예시) L/C No. HTO285955"
                        v-model="state.refnNoCd2"
                        title="참조번호2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="startDay">출항일</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>선박등의 출항일자 표기</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      placeholder="예시) 20230801"
                      id="startDay"
                      v-model="state.tkffDd"
                      v-number-format
                      title="출항일"
                      maxlength="8"
                      @change="onChangetkffDd"
                      :disabled="state.sbcpCompTrgYn"
                    />
                  </div>
                </td>
                <th scope="row">
                  질권은행
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>수입시 L/C를 오픈한 은행을 선택</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpSlt">
                    <button
                      type="button"
                      class="sltBtn"
                      title="질권은행 선택"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    >
                      <span>{{ state.bankNm }}</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.plrBnkList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('plrBnk', item)"
                        >
                          <span>{{ item.name }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pol">출항지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt" :class="{ 'input-hover': hover }">
                    <input
                      type="text"
                      id="pol"
                      title="출항지"
                      @mouseover="hover = true"
                      @mouseleave="hover = false"
                      @click="openPopup('popStplCdCityCode')"
                      v-model="state.stplCd"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="polModi">출항지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 출발항란의 도시명과 실제 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="polModi"
                      title="출항지 정정"
                      v-model="state.stplNm"
                      :disabled="state.sbcpCompTrgYn"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pod">도착지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="pod"
                      title="도착지"
                      @click="openPopup('popArarCdCityCode')"
                      v-model="state.ararCd"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="podModi">도착지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 도착항란의 도시명과 실재 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="podModi"
                      title="도착지 정정"
                      v-model="state.ararNm"
                      :disabled="state.sbcpCompTrgYn"
                    />
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">
                  <label for="claim">Claim지급지</label>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="claim"
                      title="Claim지급지"
                      v-model="state.bzacNm"
                      :disabled="state.sbcpCompTrgYn"
                    />
                  </div>
                  <div class="inpCheck mgt20">
                    <input
                      type="checkbox"
                      id="except"
                      v-model="state.sameClaim"
                    />
                    <label for="except" class="fs14 fc66">동일 지급지</label>
                  </div>
                </td>
                <th scope="row">원본부수</th>
                <td>
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="원본부수 선택">
                      <span>{{ state.ortxtCpnoNm }}</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.ortxtCpnoList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('ortxtCpno', item)"
                        >
                          <span>{{ item.name }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="startDay2">개시일</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="예시) 20230801"
                      id="startDay2"
                      title="개시일"
                      v-model="state.currentDate"
                      :disabled="state.sbcpCompTrgYn"
                      @change="onChangeinsStdt"
                    />
                  </div>
                  <p class="inpInfo fcRed">
                    개시일(청약일) 이전의 사고는 보상하지 않습니다.
                  </p>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  운송수단명
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        선박과 비행기 중 하나를 반드시 선택하시고 선박명을 알고
                        있는 경우 우측 빈칸에 입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="운송수단명 선택"
                        :disabled="!state.sbcpCompTrgYn1"
                      >
                        <span>{{ state.trnMnNmCdNm }}</span>
                      </button>
                      <ul>
                        <li
                          v-for="(item, index) in state.trnMnNmList"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            @click="onSelectEvent('trnMnNm', item)"
                          >
                            <span>{{ item.name }}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        title="운송수단명"
                        v-model="state.trnMnNm"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pdtCode">품목코드</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        보험을 가입하는 물품을 선택하십시오. 보험가입물품이 여러
                        종류일 경우에는<br />
                        INVOICE AMOUNT 가 가장 큰 품목을 대표품목으로 선택하세요
                        (HS CODE 참조)<br />
                        주의: 보험요율 산출과 클레임 처리시 중요한 사항임으로
                        주의하여 선택하세요
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="선택해 주세요"
                      id="pdtCode"
                      title="품목코드"
                      readonly
                      @click="openPopup('popPdtCode')"
                      v-model="state.itmCd"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="hsCode">H-S CODE</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        HS CODE 대분류 4 자리를 입력하시면 가입 하고자 하는
                        품목이 선택됩니다.<br />
                        해당 자료가 없는 경우 당사 해상항공업무팀<br />
                        (02-6464-3216,3218,3219,3222,3226) 으로 문의하시기
                        바랍니다.
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="클릭"
                      id="hsCode"
                      title="H-S CODE"
                      @click="openPopup('popHsCode')"
                      v-model="state.hsCd"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    />
                  </div>
                  <p class="inpInfo fcRed">
                    어획물, 화공품, 유류, 시베리아횡단철도 및 중국횡단철도화물은
                    당사로 문의 바랍니다.
                  </p>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pdt">보험목적물</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        대표품목 및 수량만 입력하셔도 됩니다. (최대 60 bytes)
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTextarea typeReq">
                    <textarea
                      placeholder="내용을 입력하세요."
                      id="pdt"
                      v-model="state.obj"
                      :disabled="state.sbcpCompTrgYn"
                    ></textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">INVOICE금액</th>
                <td colspan="3">
                  <div class="typeSplit3">
                    <dl>
                      <dt>환종</dt>
                      <dd>
                        <div class="inpSlt">
                          <button
                            type="button"
                            class="sltBtn"
                            title="환종 선택"
                            :disabled="
                              state.sbcpCompTrgYn || !state.sbcpCompTrgYn1
                            "
                          >
                            <span>{{ state.curNm }}</span>
                          </button>
                          <ul>
                            <li
                              v-for="(item, index) in state.curList"
                              :key="index"
                            >
                              <button
                                type="button"
                                class="sltOpt"
                                @click="onSelectEvent('cur', item)"
                              >
                                <span>{{ item.code }}/{{ item.name }}</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <label for="profit">희망이익률(%)</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>
                              화물이 목적지에 도착함으로써 화주가 얻을수 있는<br />
                              금전적 이익으로 110%가 일반적임.(최대 150%까지
                              입력가능)
                            </dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt typeReq">
                          <input
                            type="text"
                            id="profit"
                            title="희망이익률"
                            class="tar"
                            v-model="state.hop"
                            :disabled="
                              state.sbcpCompTrgYn || !state.sbcpCompTrgYn1
                            "
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                  <div class="typeSplit3">
                    <dl>
                      <dt>
                        <label for="load">갑판적율(%)</label>
                      </dt>
                      <dd>
                        <div class="inpTxt typeReq">
                          <input
                            type="text"
                            id="load"
                            title="갑판적율"
                            v-model="state.odshRt"
                            v-number2-format
                            :disabled="
                              state.sbcpCompTrgYn || !state.sbcpCompTrgYn1
                            "
                          />
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <label for="pay">금액</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>INVOICE가액을 입력</dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt typeReq">
                          <input
                            type="text"
                            placeholder="예시) 10000.35"
                            id="pay"
                            title="금액"
                            v-model="state.ttFormatInvcVamtAmt"
                            @input="formatAmt"
                            :disabled="
                              state.sbcpCompTrgYn || !state.sbcpCompTrgYn1
                            "
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  포장형태
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>포장형태</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      class="sltBtn"
                      title="포장형태 선택"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    >
                      <span>{{
                        state.packShNm != "" ? state.packShNm : "선박해 주세요"
                      }}</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.packShList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('packShCd', item)"
                        >
                          <span>{{ item.name }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  보험조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        ALL RISK조건만 청약입력이 가능하며 기타 조건은
                        담당자가에게 FAX로 의뢰하시고 출력만 가능합니다
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      class="sltBtn"
                      title="보험조건 선택"
                      :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                    >
                      <span id="insCnd">보험조건 선택</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.insCndList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('insCnd', item)"
                        >
                          <span
                            >{{ item.addtlCovCd }} / {{ item.addtlCovNm }}</span
                          >
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div
                    class="typeSplit4"
                    v-for="(item, index) in state.acTermsList"
                    :key="index"
                  >
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_1"
                        @click="openPopup('popAddition')"
                        v-model="item.addtlCovNm"
                        :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                      />
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_2"
                        v-model="item.text"
                        :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                      />
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_3"
                        v-model="item.addTrmUnt1"
                        :disabled="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="etc">기타조건</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        L/C 서류상 보험관련 문구를 입력하고자 할 경우 사용.(최대
                        60 bytes입력가능)
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTextarea typeReq">
                    <textarea
                      placeholder="내용을 입력하세요."
                      id="etc"
                      v-model="state.etcCnd"
                      :disabled="state.sbcpCompTrgYn"
                    ></textarea>
                  </div>
                </td>
              </tr>
              <div class="inpCheck mgt20" v-show="state.sendSmsYnflag == true">
                <input type="checkbox" id="except" v-model="state.sendSmsYn" />
                <label for="except" class="fs14 fc66">알림톡 발송</label>
              </div>
            </tbody>
          </table>
        </div>

        <div class="btnWrap">
          <a
            class="btnType sizeR colorB"
            @click="sbcpComp()"
            v-if="state.sbcpCompTrgYn || !state.sbcpCompTrgYn1"
            ><span>청약완료</span></a
          >
          <a
            class="btnType sizeR colorB"
            @click="save()"
            v-if="!state.sbcpCompTrgYn && state.sbcpCompTrgYn1"
            ><span>보험료 산출</span></a
          >
        </div>
      </div>
    </div>
  </div>

  <PopCityCode
    ref="popStplCdCityCode"
    @update:data="
      (eventData) => handleDataFromPopup('popStplCdCityCode', eventData)
    "
  ></PopCityCode>

  <PopCityCode
    ref="popArarCdCityCode"
    @update:data="
      (eventData) => handleDataFromPopup('popArarCdCityCode', eventData)
    "
  ></PopCityCode>

  <PopHsCode
    ref="popHsCode"
    @update:data="(eventData) => handleDataFromPopup('popHsCode', eventData)"
  ></PopHsCode>

  <PopAddition
    ref="popAddition"
    @update:data="(eventData) => handleDataFromPopup('popAddition', eventData)"
  ></PopAddition>
  <PopMemoW
    ref="popMemoW"
    @update:data="(eventData) => handleDataFromPopup('popMemoW', eventData)"
  ></PopMemoW>
  <PopPwChange
    ref="popPwChange"
    @update:data="(eventData) => handleDataFromPopup('popPwChange', eventData)"
  ></PopPwChange>

  <PopPdtCode
    ref="popPdtCode"
    @update:data="(eventData) => handleDataFromPopup('popPdtCode', eventData)"
    @close="handlePopupClose"
  ></PopPdtCode>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUpdate,
  getCurrentInstance,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { format } from "date-fns";
import { Decimal } from "decimal.js";

import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

import PopAddition from "@/components/common/layerPop/PopAddition.vue";
import PopMemoW from "@/components/common/layerPop/PopMemoW.vue";
import PopPdtCode from "@/components/common/layerPop/PopPdtCode.vue";
import PopPwChange from "@/components/common/layerPop/PopPwChange.vue";

import PopCityCode from "@/components/common/layerPop/PopCityCode.vue";
import PopHsCode from "@/components/common/layerPop/PopHsCode.vue";

import * as codeList from "@/common/code";
const router = useRouter();
const route = useRoute();

const axios = inject("axios");
const instance = getCurrentInstance();
const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");

const popStplCdCityCode = ref(null);
const popArarCdCityCode = ref(null);
const popPdtCode = ref(null);
const popAddition = ref(null);
const popMemoW = ref(null);
const popPwChange = ref(null);

const popHsCode = ref(null);

const hover = ref(false);
const viewChk = ref("");
const store = useStore();

const state = reactive({
  temCtgCdList: [], //팀분류 코드
  refNo1List: [], //참조번호1
  refNo2List: [], //참조번호2
  trnMnNmList: [], //운송수단명
  plrBnkList: [], //질권은행명
  ortxtCpnoList: [], //원본부수
  insCndList: [], //보험조건
  curList: [], //환종
  packShList: [], //포장형태
  n_ctoren: "", //계약자 영문명
  n_ctorkr: "", //계약자 한글명
  n_ctoren1: "", //계약자 영문명
  n_ctorkr1: "", //계약자 한글명
  n_ctoren2: "", //계약자 영문명
  n_ctorkr2: "", //계약자 한글명
  refnNoCd1: "", //참조번호
  refnNoCd2: "", //참조번호2
  tkffDd: "", //출항일
  stplCd: "", //출항항
  stplNm: "", //출항항 정정
  ararCd: "", //도착항
  ararNm: "", //도착항 정정
  bgnDt: "", //개시일자
  itmCd: "",
  itmCdNm: "",
  packShCd: "", //포장형태코드
  packShNm: "", //포장형태코드명
  cargTrnDtlsDivCd: "05",
  cmcMnUstmnYn: "2",
  acpShDivCd: "",
  currentDate: format(new Date(), "yyyyMMdd"),
  acTermsList: [{}],
  bzacId: "",
  bzacNm: "",
  korNatlNm: "",

  bankNm: "", //질권은행명
  prctrNo: "",
  ctrId: "",
  strAcpShDivCd: "",
  hisSeq: "",
  hop: "",
  odshRt: "",
  ttInvcVamtAmt: 0,
  ttFormatInvcVamtAmt: "",
  trnMnNmCd: "",
  trnMnNmCdNm: "",
  trnMnNm: "",
  hsCd: "",
  vygZoneCd: "",
  obj: "",
  etcCnd: "",
  addtlCovCd: "",
  addtlCovNm: "",
  curNm: "",
  ortxtCpnoNm: "",
  sbcpCompTrgYn: false,

  sbcpCompTrgYn1: false,

  prctrStatCd: "",

  polNo: "",
  subsInqDiv: "1",
  prctrNo: "",
  stockBunho: [],
  ResultTotal: [],

  strInsAmtPopa1: "",
  strInsAmtPopa2: "",
  ctrRelpeEngNm: "", // Claim 지급지
  ctrRelpeKorNm: "",

  sameClaim: "",

  moveTypeCd: "",
  covCd: "",
  covNm: "",

  strPrctrNo: "", // 가계약번호
  strCtrId: "", // 계약아이디
  strHisSeq: "", //이력순번

  currentDateOr: "", //개시일 -+ 5
  tkffDdOr: "", //출항일 -+ 5

  sendSmsYn: "", //알림톡 발송여부

  sendSmsYnflag: true, //알림톡 화면 유무
});

const onChangeinsStdt = () => {
  console.log(
    util.getDay(
      util.formatDate(state.currentDateOr, "yyyymmdd"),
      util.formatDate(state.currentDate, "yyyymmdd")
    )
  );
  console.log(
    util.getDay(
      util.formatDate(state.currentDate, "yyyymmdd"),
      util.formatDate(state.currentDateOr, "yyyymmdd")
    )
  );

  if (
    util.getDay(
      util.formatDate(state.currentDateOr, "yyyymmdd"),
      util.formatDate(state.currentDate, "yyyymmdd")
    ) > 5
  ) {
    swalAlert("보험개시일은 청약일자의 5일 이내로만 입력 가능합니다.");
    return false;
  } else if (
    util.getDay(
      util.formatDate(state.currentDate, "yyyymmdd"),
      util.formatDate(state.currentDateOr, "yyyymmdd")
    ) > 5
  ) {
    swalAlert("보험개시일은 청약일자의 -5 이전으로 입력하실 수 없습니다.");
    return false;
  } else {
    onChangetkffDd();
    return true;
  }
};

const onChangetkffDd = () => {
  console.log(sessionUserInfo.userInfo.agrm_nagrm_typ_cd);
  if (sessionUserInfo.userInfo.agrm_nagrm_typ_cd == "1") {
    console.log(
      util.formatDate(new Date(), "yyyy") >
        util.formatDate(state.tkffDd, "yyyy")
    );
    if (
      util.formatDate(new Date(), "yyyy") <
        util.formatDate(state.tkffDd, "yyyy") ||
      util.formatDate(new Date(), "yyyy") >
        util.formatDate(state.tkffDd, "yyyy")
    ) {
      swalAlert("출항일 년도를 확인 바랍니다.");
      return false;
    }
  } else {
    console.log(
      util.getDay(
        util.formatDate(state.tkffDdOr, "yyyymmdd"),
        util.formatDate(state.tkffDd, "yyyymmdd")
      )
    );
    console.log(
      util.getDay(
        util.formatDate(state.tkffDd, "yyyymmdd"),
        util.formatDate(state.tkffDdOr, "yyyymmdd")
      )
    );
    if (!(state.currentDate < state.tkffDd)) {
      swalAlert("출항일은 개시일 이전일자로 입력 불가합니다.");
      return false;
    } else if (
      util.getDay(
        util.formatDate(state.tkffDdOr, "yyyymmdd"),
        util.formatDate(state.tkffDd, "yyyymmdd")
      ) > 5
    ) {
      swalAlert("출항일은 기존일자의 5일 이내로만 입력 가능합니다.");
      return false;
    } else if (
      util.getDay(
        util.formatDate(state.tkffDd, "yyyymmdd"),
        util.formatDate(state.tkffDdOr, "yyyymmdd")
      ) > 5
    ) {
      swalAlert("출항일은 기존일자의 -5일 이전으로 입력하실 수 없습니다.");
      return false;
    }
  }
};

const formatAmt = () => {
  if (_.endsWith(state.ttFormatInvcVamtAmt, ".")) {
    return true;
  }
  const rawAmt = state.ttFormatInvcVamtAmt
    ?.replace(/[^0-9]+(\.[0-9]+)?$/g, "")
    .replace(/,/g, "");
  const formatted = new Intl.NumberFormat().format(rawAmt);
  state.ttInvcVamtAmt = rawAmt;
  state.ttFormatInvcVamtAmt = formatted;
};

//검색
const SearchFn = async () => {
  if (state.polNo == "" && state.prctrNo == "") {
    swalAlert("입력값을 확인하십시오.");
    return;
  }
  if (state.subsInqDiv == "") {
    state.subsInqDiv = "1";
  } else if (state.subsInqDiv == "1") {
    console.log("가계약 번호");
    let param = {
      cusNo: "",
      //subsInqDiv: state.subsInqDiv,
      //strPrctrNo: state.prctrNo,
      acpShDivCd: "",
      inetUsrId: "",
      // endrHisStdNo: "0",
      // inetDivCd: "1",
      prctrNo: state.prctrNo,
    };

    let result = await axios.transaction("FNGCTNFO0074", param);
    if (_.isEmpty(result.body)) {
      //해당 조건에 맞는 자료가 없습니다.
      swalAlert(result.msg.standMsg);
      return;
    }

    let mrinSbcDsgCtrRelpeInfBcVo = _.flatten([
      result.body.mrinSbcDsgCtrRelpeInfBcVo,
    ]);
    let temp = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
      return d.ctrPtyRlCd == "01";
    });

    if (temp[0].ctrRelpeEngNm != state.n_ctoren.trim()) {
      swalAlert("조회할수 없는 계약 입니다.");
      return;
    } else {
      state.inetUsrId = result.body.inetUsrId;
      state.pdCd = result.body.pdCd;
      state.untPdCd = result.body.untPdCd;
      state.prctrNo = result.body.prctrNo;
      state.ctrId = result.body.ctrId;
      state.insStdt = result.body.insStdt;
      state.sbcpDt = result.body.sbcpDt;
      state.cusNo = result.body.cusNo;
      state.hisSeq = result.body.hisSeq;

      let prctrDtlConBcVo = result.body.prctrDtlConBcVo;
      let mrinSbcDsgCovInfBcVo = result.body.mrinSbcDsgCovInfBcVo;
      let cargSbcDsgObjInfBcVo = result.body.cargSbcDsgObjInfBcVo;
      let gnrMrinFtrnOdVo = result.body.gnrMrinFtrnOdVo;

      let mrinSbcDsgCtrRelpeInfBcVo = result.body.mrinSbcDsgCtrRelpeInfBcVo;

      _.each(prctrDtlConBcVo, function (value, idx) {
        let ctrConCd = value.ctrConCd;

        if (ctrConCd == "G002") {
          state.obj = value.dtlCon; //목적물
        } else if (ctrConCd == "G003") {
          state.etcCnd = value.dtlCon; //기타목적
        }
      });

      state.acTermsList = [];
      if (mrinSbcDsgCovInfBcVo.length == null) {
        if (mrinSbcDsgCovInfBcVo.covDivCd == "1") {
          let acTerms = {};
          acTerms.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
          acTerms.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
          acTerms.addTrm1 = mrinSbcDsgCovInfBcVo.covtpAddTrmDiv;
          acTerms.text = mrinSbcDsgCovInfBcVo.covtpAddTrmVal;
          acTerms.addTrmUnt1 = mrinSbcDsgCovInfBcVo.addTrmUnt;
          state.insCndList.push(acTerms);
          var insCnd = document.getElementById("insCnd");
          insCnd.innerText =
            mrinSbcDsgCovInfBcVo.covCd + " / " + mrinSbcDsgCovInfBcVo.covNm;
          state.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
          state.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
          state.acTermsList = [{}];
        }
      } else {
        _.each(mrinSbcDsgCovInfBcVo, function (value, idx) {
          let covDivCd = value.covDivCd;
          //부가담보

          if (covDivCd == "1") {
            let acTerms = {};
            acTerms.addtlCovCd = value.covCd;
            acTerms.addtlCovNm = value.covNm;
            acTerms.addTrm1 = value.covtpAddTrmDiv;
            acTerms.text = value.covtpAddTrmVal;
            acTerms.addTrmUnt1 = value.addTrmUnt;
            state.insCndList.push(acTerms);
            var insCnd = document.getElementById("insCnd");
            insCnd.innerText = value.covCd + " / " + value.covNm;
            state.addtlCovCd = value.covCd;
            state.addtlCovNm = value.covNm;
          } else if (covDivCd == "2") {
            let acTerms = {};
            acTerms.addtlCovCd = value.covCd;

            acTerms.addtlCovNm = value.covNm;
            acTerms.addTrm1 = value.covtpAddTrmDiv;
            acTerms.text = value.covtpAddTrmVal;
            acTerms.addTrmUnt1 = value.addTrmUnt;
            state.acTermsList.push(acTerms);
          } else if (covDivCd == null) {
            state.acTermsList = [{}];
          }
        });
      }

      //참조번호1 셋팅
      state.refnNoCd1 = result.body.refnNoCd1;
      state.refNo1 = result.body.refnNoDivCd1;
      _.each(state.refNo1List, function (value, idx) {
        if (state.refNo1 == value.code) {
          state.refNoNm1 = value.name;
        }
      });
      var refNo1 = document.getElementById("refNo1");
      refNo1.innerText = state.refNoNm1;

      //참조번호2 셋팅
      state.refnNoCd2 = result.body.refnNoCd2;
      state.refNo2 = result.body.refnNoDivCd2;

      _.each(state.refNo2List, function (value, idx) {
        if (state.refNo2 == value.code) {
          state.refNoNm2 = value.name;
        }
      });
      var refNo2 = document.getElementById("refNo2");
      refNo2.innerText = state.refNoNm2;

      //계약자 , 피보험자 , 질권자 셋팅
      _.each(mrinSbcDsgCtrRelpeInfBcVo, function (value, idx) {
        let ctrPtyRlCd = value.ctrPtyRlCd;

        //질권자 셋팅
        if (ctrPtyRlCd == "02") {
          state.n_ctorkr1 = value.ctrRelpeKorNm;
          state.n_ctoren1 = value.ctrRelpeEngNm;
        } else if (ctrPtyRlCd == "11") {
          state.bankNm = value.ctrRelpeKorNm;
          state.plrBnk = value.ptyId;
        } else if (ctrPtyRlCd == "23") {
          state.bzacNm = value.ctrRelpeEngNm;
          state.bzacId = value.ptyId;
        } else if (ctrPtyRlCd == "22") {
          state.sameClaim = true;
        }
      });

      //출항일 셋팅 -- 복사 설계시 셋팅하지 않음
      //state.tkffDd = result.body.tkffDd;

      //출발지 셋팅
      state.stplCd = result.body.stplCd;
      state.stplNm = result.body.stplNm;

      //도착지 셋팅
      state.ararCd = result.body.ararCd;
      state.ararNm = result.body.ararNm;

      //원본부수 셋팅
      let polOrtxtNum = result.body.polOrtxtNum;
      state.ortxtCpno = polOrtxtNum;

      _.each(state.ortxtCpnoList, function (value, idx) {
        if (state.ortxtCpno == value.code) {
          state.ortxtCpnoNm = value.name;
        }
      });

      //운송코드 셋팅
      let trnMnCd = gnrMrinFtrnOdVo.trnMnCd;
      state.trnMnNmCd = trnMnCd;

      _.each(state.trnMnNmList, function (value, idx) {
        if (state.trnMnNmCd == value.code) {
          state.trnMnNmCdNm = value.name;
        }
      });

      //운송수단명 셋팅
      let ftrnOdNm = gnrMrinFtrnOdVo.ftrnOdNm;
      state.trnMnNm = ftrnOdNm;

      //개시일 셋팅
      state.currentDate = result.body.sbcpDt;

      //품목코드 셋팅
      let itmCd = cargSbcDsgObjInfBcVo.itmCd;
      state.itmCd = itmCd;

      //H-S CODE 셋팅
      let hsCd = cargSbcDsgObjInfBcVo.hsCd;
      state.hsCd = hsCd;

      //포장 형태 셋팅
      let packCd = cargSbcDsgObjInfBcVo.packCd;
      state.packShCd = packCd;
      _.each(state.packShList, function (value, idx) {
        if (packCd == value.code) {
          state.packShNm = value.name;
        }
      });

      //희망 이익률
      let hopPftRt = result.body.hopPftRt;
      state.hop = hopPftRt;

      //입력 금액 -- 복사 설계시 셋팅하지 않음
      //let ttInvcVamtAmt = result.body.ttInvcVamtAmt;
      //state.ttInvcVamtAmt = ttInvcVamtAmt;
      //state.ttFormatInvcVamtAmt = ttInvcVamtAmt; //검색시 소수점 맞추기
      //formatAmt();

      //갑판적율
      let odshRt = result.body.odshRt;
      state.odshRt = odshRt;

      //보험가입금액 환종코드 셋팅
      let insVamtCurCd = result.body.insVamtCurCd;
      state.cur = insVamtCurCd;

      _.each(state.curList, function (value, idx) {
        if (insVamtCurCd == value.code) {
          state.curNm = value.code + "/" + value.name;
        }
      });

      retrieveBasCov();
      state.sbcpCompTrgYn = false;
    }
    //
    //
  } else if (state.subsInqDiv == "2") {
    console.log("진계약번호 / 참조 번호");
    let param = {
      // subsInqDiv: state.subsInqDiv,
      acpShDivCd: "",
      inetUsrId: "",
      // endrHisStdNo: "0",
      cusNo: sessionUserInfo.slzCusInf.cusNo,
      inetDivCd: "1",
      polNo: state.polNo, //21010-1632156
    };

    console.log("result");
    let result = await axios.transaction("FNGCTNFO0142", param);
    let mrinSbcDsgCtrRelpeInfBcVo = _.flatten([
      result.body.mrinSbcDsgCtrRelpeInfBcVo,
    ]);
    let temp = _.filter(mrinSbcDsgCtrRelpeInfBcVo, (d) => {
      return d.ctrPtyRlCd == "01";
    });
    console.log(temp);
    if (temp[0].ctrRelpeEngNm != state.n_ctoren.trim()) {
      swalAlert("조회할수 없는 계약 입니다.");
      return;
    } else {
      state.inetUsrId = result.body.inetUsrId;
      state.pdCd = result.body.pdCd;
      state.untPdCd = result.body.untPdCd;
      state.prctrNo = result.body.prctrNo;
      state.ctrId = result.body.ctrId;
      state.insStdt = result.body.insStdt;
      state.sbcpDt = result.body.sbcpDt;
      state.cusNo = result.body.cusNo;
      state.hisSeq = result.body.hisSeq;
      //항만추가
      state.vygZoneCd = result.body.vygZoneCd;

      let prctrDtlConBcVo = result.body.prctrDtlConBcVo;
      let mrinSbcDsgCovInfBcVo = result.body.mrinSbcDsgCovInfBcVo;
      let cargSbcDsgObjInfBcVo = result.body.cargSbcDsgObjInfBcVo;
      let gnrMrinFtrnOdVo = result.body.gnrMrinFtrnOdVo;

      let mrinSbcDsgCtrRelpeInfBcVo = result.body.mrinSbcDsgCtrRelpeInfBcVo;

      _.each(prctrDtlConBcVo, function (value, idx) {
        let ctrConCd = value.ctrConCd;

        if (ctrConCd == "G002") {
          state.obj = value.dtlCon; //목적물
        } else if (ctrConCd == "G003") {
          state.etcCnd = value.dtlCon; //기타목적
        }
      });

      state.acTermsList = [];
      if (mrinSbcDsgCovInfBcVo.length == null) {
        if (mrinSbcDsgCovInfBcVo.covDivCd == "1") {
          let acTerms = {};
          acTerms.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
          acTerms.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
          acTerms.addTrm1 = mrinSbcDsgCovInfBcVo.covtpAddTrmDiv;
          acTerms.text = mrinSbcDsgCovInfBcVo.covtpAddTrmVal;
          acTerms.addTrmUnt1 = mrinSbcDsgCovInfBcVo.addTrmUnt;
          state.insCndList.push(acTerms);
          var insCnd = document.getElementById("insCnd");
          insCnd.innerText =
            mrinSbcDsgCovInfBcVo.covCd + " / " + mrinSbcDsgCovInfBcVo.covNm;
          state.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
          state.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
          state.acTermsList = [{}];
        }
      } else {
        _.each(mrinSbcDsgCovInfBcVo, function (value, idx) {
          let covDivCd = value.covDivCd;
          //부가담보

          if (covDivCd == "1") {
            let acTerms = {};
            acTerms.addtlCovCd = value.covCd;
            acTerms.addtlCovNm = value.covNm;
            acTerms.addTrm1 = value.covtpAddTrmDiv;
            acTerms.text = value.covtpAddTrmVal;
            acTerms.addTrmUnt1 = value.addTrmUnt;
            state.insCndList.push(acTerms);
            var insCnd = document.getElementById("insCnd");
            insCnd.innerText = value.covCd + " / " + value.covNm;
            state.addtlCovCd = value.covCd;
            state.addtlCovNm = value.covNm;
          } else if (covDivCd == "2") {
            let acTerms = {};
            acTerms.addtlCovCd = value.covCd;

            acTerms.addtlCovNm = value.covNm;
            acTerms.addTrm1 = value.covtpAddTrmDiv;
            acTerms.text = value.covtpAddTrmVal;
            acTerms.addTrmUnt1 = value.addTrmUnt;
            state.acTermsList.push(acTerms);
          } else if (covDivCd == null) {
            state.acTermsList = [{}];
          }
        });
      }
      //참조번호1 셋팅
      state.refnNoCd1 = result.body.refnNoCd1;
      state.refNo1 = result.body.refnNoDivCd1;
      _.each(state.refNo1List, function (value, idx) {
        if (state.refNo1 == value.code) {
          state.refNoNm1 = value.name;
        }
      });
      var refNo1 = document.getElementById("refNo1");
      refNo1.innerText = state.refNoNm1;

      //참조번호2 셋팅
      state.refnNoCd2 = result.body.refnNoCd2;
      state.refNo2 = result.body.refnNoDivCd2;

      _.each(state.refNo2List, function (value, idx) {
        if (state.refNo2 == value.code) {
          state.refNoNm2 = value.name;
        }
      });
      var refNo2 = document.getElementById("refNo2");
      refNo2.innerText = state.refNoNm2;

      //계약자 , 피보험자 , 질권자 셋팅
      _.each(mrinSbcDsgCtrRelpeInfBcVo, function (value, idx) {
        let ctrPtyRlCd = value.ctrPtyRlCd;

        //질권자 셋팅
        if (ctrPtyRlCd == "02") {
          state.n_ctorkr1 = value.ctrRelpeKorNm;
          state.n_ctoren1 = value.ctrRelpeEngNm;
        } else if (ctrPtyRlCd == "11") {
          state.bankNm = value.ctrRelpeKorNm;
          state.plrBnk = value.ptyId;
        } else if (ctrPtyRlCd == "23") {
          state.bzacNm = value.ctrRelpeEngNm;
          state.bzacId = value.ptyId;
        } else if (ctrPtyRlCd == "22") {
          state.sameClaim = true;
        }
      });

      //출항일 셋팅 -- 복사 설계시 셋팅하지 않음
      //state.tkffDd = result.body.tkffDd;

      //출발지 셋팅
      state.stplCd = result.body.stplCd;
      state.stplNm = result.body.stplNm;

      //도착지 셋팅
      state.ararCd = result.body.ararCd;
      state.ararNm = result.body.ararNm;

      //원본부수 셋팅
      let polOrtxtNum = result.body.polOrtxtNum;
      state.ortxtCpno = polOrtxtNum;

      _.each(state.ortxtCpnoList, function (value, idx) {
        if (state.ortxtCpno == value.code) {
          state.ortxtCpnoNm = value.name;
        }
      });

      //운송코드 셋팅
      let trnMnCd = gnrMrinFtrnOdVo.trnMnCd;
      state.trnMnNmCd = trnMnCd;

      _.each(state.trnMnNmList, function (value, idx) {
        if (state.trnMnNmCd == value.code) {
          state.trnMnNmCdNm = value.name;
        }
      });

      //운송수단명 셋팅
      let ftrnOdNm = gnrMrinFtrnOdVo.ftrnOdNm;
      state.trnMnNm = ftrnOdNm;

      //개시일 셋팅
      state.currentDate = result.body.sbcpDt;

      //품목코드 셋팅
      let itmCd = cargSbcDsgObjInfBcVo.itmCd;
      state.itmCd = itmCd;

      //H-S CODE 셋팅
      let hsCd = cargSbcDsgObjInfBcVo.hsCd;
      state.hsCd = hsCd;

      //포장 형태 셋팅
      let packCd = cargSbcDsgObjInfBcVo.packCd;
      state.packShCd = packCd;
      _.each(state.packShList, function (value, idx) {
        if (packCd == value.code) {
          state.packShNm = value.name;
        }
      });

      //희망 이익률
      let hopPftRt = result.body.hopPftRt;
      state.hop = hopPftRt;

      //입력 금액 -- 복사 설계시 셋팅하지 않음
      //let ttInvcVamtAmt = result.body.ttInvcVamtAmt;
      // state.ttInvcVamtAmt = ttInvcVamtAmt;
      //state.ttFormatInvcVamtAmt = ttInvcVamtAmt; //검색시 소수점 맞추기
      //formatAmt();

      //갑판적율
      let odshRt = result.body.odshRt;
      state.odshRt = odshRt;

      //보험가입금액 환종코드 셋팅
      let insVamtCurCd = result.body.insVamtCurCd;
      state.cur = insVamtCurCd;

      _.each(state.curList, function (value, idx) {
        if (insVamtCurCd == value.code) {
          state.curNm = value.code + "/" + value.name;
        }
      });

      retrieveBasCov();
      state.sbcpCompTrgYn = false;
    }
  }
};

//팝업 확인콜백
const handleDataFromPopup = async (popupId, eventData) => {
  if (popupId == "popStplCdCityCode") {
    state.stplCd = eventData.d.CITY_NTN_CD.trim();
    state.stplNm =
      eventData.d.CITY_NTN_NM.trim() + "/" + eventData.d.NTN_NM.trim();
    state.vygZoneCd = eventData.d.VOYAGE_AREA_CD;
  } else if (popupId == "popArarCdCityCode") {
    state.ararCd = eventData.d.CITY_NTN_CD.trim();
    state.ararNm =
      eventData.d.CITY_NTN_NM.trim() + "/" + eventData.d.NTN_NM.trim();

    var param = {};
    param.cityNatlCd = state.ararCd;

    if ("KO" == state.ararCd.substring(0, 2)) {
      param.domeOvrseaDivCd = "1";
    } else {
      param.domeOvrseaDivCd = "2";
    }

    //손사 법인조회
    let result = await axios.transaction("FNGCLMAO0004", param);
    if (_.isArray(result.body.cladjCrpInqDtlBcVo)) {
      state.bzacId = result.body.cladjCrpInqDtlBcVo[0].bzacId;
      state.bzacNm = result.body.cladjCrpInqDtlBcVo[0].bzacNm;
    } else {
      state.bzacId = result.body.cladjCrpInqDtlBcVo?.bzacId;
      state.bzacNm = result.body.cladjCrpInqDtlBcVo?.bzacNm;
    }
  } else if (popupId == "popPdtCode") {
    if ("216010100" == eventData.itmCd) {
      swalConfirm(
        "본사는 중고기계및 기기를 적하보험으로써 인수하지 않습니다.\n이 사항을 숙지하였고 해당 품목이 중고기계및 기기가 아님을\n확인하셨습니까?"
      ).then((result) => {
        //예
        if (result.isConfirmed) {
          state.itmCd = eventData.itmCd;
        }
      });
    } else if ("303010100" == eventData.itmCd) {
      swalConfirm(
        "가구류, 자개류(조가비포함), 표구, 회화 및 Dry Flower등 깨지기 쉬운 화물에 대해 A/R, A/R(Air). ICC(A), ICC(Air)로 가입하는 경우에도 Breakage 위험을 별도로 가입하여야 하며(가입을 원하는 경우 부가조건에서 Breakage를 선택하십시오), Breakage 위험을 추가 담보하지 않는 경우 파손으로 기인한 여하한 손상은 담보하지 않음을 확인하셨습니까?"
      ).then((result) => {
        //예
        if (result.isConfirmed) {
          state.itmCd = eventData.itmCd;
        }
      });
    } else {
      if (eventData.itmCd != state.itmCd) {
        state.itmCd = eventData.itmCd;
        state.itmCdNm = eventData.itmNm;
        state.hsCd = "";

        var insCnd = document.getElementById("insCnd");
        insCnd.innerText = "";

        state.addtlCovCd = "";
        state.addtlCovNm = "";
        state.packShNm = "";
        state.acTermsList = [{}];
      }
      state.itmCd = eventData.itmCd;
      state.itmCdNm = eventData.itmNm;
    }
  } else if (popupId == "popAddition") {
    if (eventData.filterObject < 1) {
      state.acTermsList = [{}];
      return;
    }
    state.acTermsList = eventData.filterObject;
  } else if (popupId == "popHsCode") {
    state.hsCd = eventData;
  }
};

//저장
const save = async () => {
  if (!onChangeinsStdt()) {
    return;
  }

  if (state.crpNo == "1101110003668" && state.crpNo == "1101110003668") {
    swalAlert(
      "귀사는 인터넷 청약이 되지 않습니다.\n해상항공업무팀 (02-6464-3216, 3218, 3219, 3222, 3226)으로 문의 또는 청약하시기 바랍니다."
    );
    return;
  }

  if (_.isEmpty(state.tkffDd)) {
    swalAlert("출항일을 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.stplCd)) {
    swalAlert("출항항(국가) 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.ararCd)) {
    swalAlert("도착항(국가) 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.itmCd)) {
    swalAlert("품목코드를 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.obj)) {
    swalAlert("첫번째 보험목적물을 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.cur)) {
    swalAlert("환종을 선택해주세요.");
    return;
  }

  if (state.hop < 110) {
    swalAlert("희망이익률을 확인하십시요(110~130)");
    return;
  }
  if (state.hop >= 130) {
    swalAlert(
      "희망이익률 130% 이상 입력시 </br> 해상항공업무팀으로 문의 주시기 바랍니다.</br> 02-6464-3216/3218/3219/3222/3226"
    );
    return;
  }

  if (_.isEmpty(state.ttInvcVamtAmt)) {
    swalAlert("INVOICE금액을 입력해주세요.");
    return;
  }

  if (_.isEmpty(state.trnMnNmCd)) {
    swalAlert("운송수단을 선택하세요.");
    return;
  }

  if (_.isEmpty(state.packShCd)) {
    swalAlert("포장형태를 선택하세요.");
    return;
  }

  if (_.isEmpty(state.addtlCovCd)) {
    swalAlert("보험조건을 선택하세요.");
    return;
  }

  var odshYn = "N"; //갑판적율 적용 여부

  // 추가 해상가입설계담보정보 (mrinSbcDsgCovInfBcVo)
  _.each(state.acTermsList, function (value, idx) {
    if (
      value.addtlCovCd == "21242A" ||
      value.addtlCovCd == "21233A" ||
      value.addtlCovCd == "21234A"
    ) {
      odshYn = "Y";
    }
  });

  if (odshYn == "Y") {
    // 정규식 비교
    var regexp = /^\d*(\.\d{0,2})?$/;
    if (!regexp.test(state.odshRt)) {
      swalAlert("갑판적율은 소숫점 2자리까지 입력 가능합니다.");
      return;
    }

    // 갑판적율이 0 이하이거나 100보다 큰 경우
    if (state.odshRt <= 0 || state.odshRt > 100) {
      swalAlert("갑판적율은 0% 이하 또는 100%초과할 수 없습니다.");
      return;
    }
  } else {
    state.odshRt = 0;
  }

  let voMap = {};
  let mrinSbcDsgCovInfBcVo = {};
  let mrinSbcDsgCtrRelpeInfBcVo = {};
  let prctrDtlConBcVo = {};
  let gnrMrinFtrnOdVo = {};
  // let cargSbcDsgInfBcVo = {};
  let cargSbcDsgObjInfBcVo = {};

  let mrinSbcDsgCovInfBcVoList = [];
  let mrinSbcDsgCtrRelpeInfBcVoList = [];
  let prctrDtlConBcVoList = [];
  let gnrMrinFtrnOdVoList = [];
  // let cargSbcDsgInfBcVoList = [];
  let cargSbcDsgObjInfBcVoList = [];

  // let calcInsuPremYn = "Y";
  // let strVo = "";
  // let strMrinSbcDsgCovInfBcVo = "";
  // let strMrinSbcDsgCtrRelpeInfBcVo = "";
  // let strPrctrDtlConBcVo = "";
  // let strGnrMrinFtrnOdVo = "";
  // let strCargSbcDsgInfBcVo = "";
  // let strCargSbcDsgObjInfBcVo = "";

  //복사 설계시 사용x
  // let strPrctrNo = state.prctrNo; // 가계약번호
  // let strCtrId = state.ctrId; // 계약아이디
  // let strHisSeq = state.hisSeq;

  if (state.prctrStatCd == 3) {
    state.strPrctrNo = state.prctrNo; // 가계약번호
    state.strCtrId = state.ctrId; // 계약아이디
    state.strHisSeq = state.hisSeq;
  }

  let strAcpShDivCd = sessionUserInfo.userInfo.polhd_gb;
  if (_.isEmpty(strAcpShDivCd)) {
    strAcpShDivCd = "1";
  }
  let strInetUsrId = sessionUserInfo.userInfo.login_id;
  let strAgrmNagrmDiv = sessionUserInfo.userInfo.agrm_nagrm_typ_cd;

  let strAplExrtDt = state.currentDate; // 적용환율일자
  let strArarCd = state.ararCd; // 도착지코드 (ararCd)
  let strArarNm = state.ararNm; // 도착지명 (ararNm)

  let strBizpeNo = sessionUserInfo.userInfo.biz_no; // 사업자번호

  let strCargTrnDtlsDivCd = "05";
  let strCmcMnUstmnYn = "2"; // 통신수단이용해지여부
  let strDsgDivCd = "1"; // 설계구분코드(dsgDivCd)
  let strDsgDt = state.currentDate; // 설계일자

  let strHopPftRt = state.hop;

  if (strHopPftRt == "") {
    strHopPftRt = "110";
  }

  let strOdshRt = state.odshRt;

  if (strOdshRt == "") {
    strOdshRt = "0";
  }
  let strInsStdt = state.currentDate; // 보험시기 (insStdt)
  let strInsVamtCurCd = state.cur; // 보험가액환종코드 (insVamtCurCd)
  let strPdCd = sessionUserInfo.userInfo.expt_prod_cd; // 상품코드 (pdCd)
  let strPolOrtxtNum = state.ortxtCpno; // 증권원본수 (polOrtxtNum)
  let strPyMd = "99"; // 납입방법
  let strRefnNoCd1 = state.refnNoCd1; // 참고번호코드1 (refnNoCd1)
  let strRefnNoCd2 = state.refnNoCd2; // 참고번호코드2 (refnNoCd2)
  let strRefnNoDivCd1 = state.refNo1; // 참고번호구분코드1 (refnNoDivCd1)
  let strRefnNoDivCd2 = state.refNo2; // 참고번호구분코드2 (refnNoDivCd2)
  let strSbcpChnDivCd = "03"; // 청약채널구분코드
  let strSbcpDt = state.currentDate; // 청약일자
  let strStplCd = state.stplCd; // 출발지코드 (stplCd)
  let strStplNm = state.stplNm; // 출발지명 (stplNm)
  let strTkffDd = state.tkffDd; // 출항일 (tkffDd)
  let strTtInvcVamtAmt = state.ttInvcVamtAmt;
  if (strTtInvcVamtAmt == "") {
    strTtInvcVamtAmt = "0";
  }
  let strTtInvcVamtCur = state.cur; // 총송장가액환종 (ttInvcVamtCur)

  let strUntPdCd = sessionUserInfo.userInfo.expt_unit_prod_cd; // 단위상품코드 (untPdCd)

  // let strUY = "2023"; // UY (uY)
  let strUY = util.formatDate(new Date(), "yyyy"); // UY (uY)
  let strVygZoneCd = ""; // 항해구역코드 (vygZoneCd)

  let strAdjtCd = state.dtil_cd; // 정산코드 (adjtCd)
  let strCtrRelpeEngNm = state.n_ctoren; // 계약관계자영문명 (ctrRelpeEngNm)
  let strInsr_En = ""; // 계약관계자영문명 (피보험자1, 2, 3)
  let strCtrRelpeKorNm = state.n_ctorkr; // 계약관계자한글명 (ctrRelpeKorNm)
  let strInsr_kor = ""; // 계약관계자한글명 (피보험자1, 2, 3)
  let strCusNo = sessionUserInfo.slzCusInf.cusNo; // 고객번호 (cusNo)

  let strPtyId = sessionUserInfo.slzCusInf.slzCusId;

  if (strPtyId == "") {
    sessionUserInfo.slzCusInf.cusId;
  }
  let strDtlCon = ""; // 상세내용 (dtlCon)
  let strFtrnOdNm = state.trnMnNm; // 운송용구명 (ftrnOdNm)

  let strTrnMnCd = state.trnMnNmCd; // 운송수단코드 (trnMnCd)
  let strHsCd = state.hsCd; // HS코드 (hsCd)
  let strInvcVamt = strTtInvcVamtAmt; // 송장가액 (invcVamt)
  let strInvcVamtCurCd = strTtInvcVamtCur; // 송장가액환종코드 (invcVamtCurCd)
  let strItmCd = state.itmCd; // 품목코드 (itmCd)
  let strItmCdNm = state.itmCdNm; // 품목코드명
  let strPackCd = state.packShCd; // 포장코드 ()
  state.ctrRelpeEngNm = state.bzacNm; // Claim 지급지
  state.ctrRelpeKorNm = state.bzacNm; // Claim 지급지
  state.strInsAmtPopa1 = state.bzacId; // 보험금지급지 코드 (insAmtPopa1)

  let ctrRelpeEngNm2 = state.bzacNm; // Claim 지급지2
  let ctrRelpeKorNm2 = state.bzacNm; // Claim 지급지2
  let strInsAmtPopa2 = state.bzacId; // 보험금지급지 코드2 (insAmtPopa1)

  let strJilkunCd = state.plrBnk; // 질권자 코드
  let strJilkunNm = state.bankNm; // 질권자 코드
  let strPrctrStatCd = ""; // 상태코드: 1-심사대상, 3-심사완료

  strStplNm = strStplNm.replaceAll("&", "&amp;"); // 출발지명
  strArarNm = strArarNm.replaceAll("&", "&amp;"); // 도착지명

  //도착항, 출항항이 모두 KO가 아닌경우-> 청약제어(2014.05.20)
  if ("KO" != strArarCd.substring(0, 2) && "KO" != strStplCd.substring(0, 2)) {
    strCargTrnDtlsDivCd = "06"; //도착항, 출항항이 모두 KO가 아닌경우-> 적하운송세부구분코드 ='06'(삼국간) (14.08.05 김혜민)
  }

  // 수입보험 : 클레임 지급지 = MERITZ FIRE & MARINE INSURANCE CO.,LTD.
  if ("KO" == strArarCd.substring(0, 2)) {
    state.strInsAmtPopa1 = "2NDVTzrhCC";
    strPdCd = sessionUserInfo.userInfo.incm_prod_cd;
    strUntPdCd = sessionUserInfo.userInfo.incm_unit_prod_cd;
    strVygZoneCd = state.vygZoneCd;
    //20130421 수입일 경우 클레임지급지 MERITZ FIRE & MARINE INSURANCE CO.,LTD.
    state.ctrRelpeKorNm = "MERITZ FIRE & MARINE INSURANCE CO.,LTD.";
    state.ctrRelpeEngNm = "MERITZ FIRE & MARINE INSURANCE CO.,LTD.";
  }

  //복사 설계시 사용x
  // voMap.prctrNo = strPrctrNo.trim();
  // voMap.ctrId = strCtrId;
  // voMap.hisSeq = strHisSeq;

  if (state.prctrStatCd == 3) {
    voMap.prctrNo = state.strPrctrNo.trim();
    voMap.ctrId = state.strCtrId;
    voMap.hisSeq = state.strHisSeq;
  }

  voMap.acpShDivCd = strAcpShDivCd.trim();
  voMap.inetUsrId = strInetUsrId;
  voMap.agrmNagrmDiv = strAgrmNagrmDiv;
  voMap.aplExrtDt = strAplExrtDt;
  voMap.ararCd = strArarCd;
  voMap.ararNm = strArarNm;
  voMap.basCovCd = state.addtlCovCd;
  voMap.bizpeNo = strBizpeNo;
  voMap.cargTrnDtlsDivCd = strCargTrnDtlsDivCd;
  voMap.cmcMnUstmnYn = strCmcMnUstmnYn;
  voMap.dsgDivCd = strDsgDivCd;
  voMap.dsgDt = strDsgDt;
  voMap.hopPftRt = strHopPftRt;
  voMap.odshRt = strOdshRt;
  voMap.insStdt = strInsStdt;
  voMap.insVamtCurCd = strInsVamtCurCd;
  voMap.pdCd = strPdCd;
  voMap.polOrtxtNum = strPolOrtxtNum;
  voMap.pyMd = strPyMd;
  voMap.refnNoCd1 = strRefnNoCd1;
  voMap.refnNoCd2 = strRefnNoCd2;
  voMap.refnNoDivCd1 = strRefnNoDivCd1;
  voMap.refnNoDivCd2 = strRefnNoDivCd2;
  voMap.sbcpChnDivCd = strSbcpChnDivCd;
  voMap.sbcpDt = strSbcpDt;
  voMap.stplCd = strStplCd;
  voMap.stplNm = strStplNm;
  voMap.tkffDd = strTkffDd;
  voMap.ttInvcVamtAmt = strTtInvcVamtAmt;
  voMap.ttInvcVamtCur = strTtInvcVamtCur;
  voMap.untPdCd = strUntPdCd;
  voMap.uY = strUY;
  voMap.vygZoneCd = strVygZoneCd;
  voMap.trnMnCd1 = strTrnMnCd;
  voMap.dsgDiv = "2";
  voMap.polhdDiv = "1"; // 계약자구분은 일반계약자로 default set
  voMap.prctrStatCd = strPrctrStatCd;
  let ttSbcAmt = new Decimal(strTtInvcVamtAmt);

  console.log(ttSbcAmt instanceof Decimal);
  ttSbcAmt = Decimal.mul(ttSbcAmt, new Decimal(strHopPftRt));
  ttSbcAmt = ttSbcAmt.div(new Decimal("100"));
  ttSbcAmt = ttSbcAmt.toDecimalPlaces(2, Decimal.ROUND_FLOOR); //총가입금액 (송장금액*희망이		익률)

  voMap.ttSbcAmt = ttSbcAmt.toString();

  /*



*/
  // 해상가입설계담보정보 (mrinSbcDsgCovInfBcVo)

  mrinSbcDsgCovInfBcVo = {};

  mrinSbcDsgCovInfBcVo.covCd = state.addtlCovCd;
  mrinSbcDsgCovInfBcVo.covNm = state.addtlCovNm;
  mrinSbcDsgCovInfBcVo.covDivCd = "1";

  //mrinSbcDsgCovInfBcVo.covtpAddTrmDiv = stArr[4];
  //mrinSbcDsgCovInfBcVo.covtpAddTrmVal = stArr[5];
  mrinSbcDsgCovInfBcVoList.push(mrinSbcDsgCovInfBcVo);

  // 추가 해상가입설계담보정보 (mrinSbcDsgCovInfBcVo)
  _.each(state.acTermsList, function (value, idx) {
    mrinSbcDsgCovInfBcVo = {};
    mrinSbcDsgCovInfBcVo.covCd = value.addtlCovCd;
    mrinSbcDsgCovInfBcVo.covDivCd = "2";

    mrinSbcDsgCovInfBcVo.covNm = value.addtlCovNm;
    mrinSbcDsgCovInfBcVo.covtpAddTrmDiv = value.addTrm1;
    mrinSbcDsgCovInfBcVo.covtpAddTrmVal = value.text;
    mrinSbcDsgCovInfBcVo.addTrmUnt = value.addTrmUnt1;
    mrinSbcDsgCovInfBcVoList.push(mrinSbcDsgCovInfBcVo);
  });

  // 해상가입설계계약관계자정보 (mrinSbcDsgCtrRelpeInfBcVo)
  // 01 : 계약자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "01";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "계약자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = sessionUserInfo.userInfo.corp_no;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strCtrRelpeEngNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strCtrRelpeKorNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = strCusNo;

  let ind_corp_typ_cd = sessionUserInfo.userInfo.ind_corp_typ_cd;
  let cusTpCd = "";
  if (ind_corp_typ_cd == "C") {
    cusTpCd = "4";
  } else {
    cusTpCd = "2";
  }

  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "03";
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = strPtyId;
  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 계약관계자영문명 (피보험자1, 2, 3)
  // strInsr_En += state.n_ctoren;
  strInsr_En += state.n_ctoren1;
  // strInsr_En += state.n_ctoren2;

  // 계약관계자한글명 (피보험자1, 2, 3)
  // strInsr_kor += state.n_ctorkr;
  strInsr_kor += state.n_ctorkr1;
  // strInsr_kor += state.n_ctorkr2;

  // 02 : 피보험자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "02";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "피보험자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = sessionUserInfo.userInfo.corp_no;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strInsr_En.trim();
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strInsr_kor.trim();
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = strCusNo;
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "03"; // 당사자구분코드 (03 : 영업고객)
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = strPtyId;

  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 23 : 검정업체 (Claim 지급지)
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "23";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "검정업체";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = state.strInsAmtPopa1;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = state.ctrRelpeEngNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = state.ctrRelpeKorNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "02"; // 당사자구분코드 (03 : 영업고객)
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = state.strInsAmtPopa1;

  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  if (state.sameClaim == true) {
    // if checkbox is checked
    console.log("555", state.sameClaim);
    // 22 : 손해사정업체
    mrinSbcDsgCtrRelpeInfBcVo = {};
    mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
    mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
    mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "22";
    mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "손해사정업체";
    mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
    mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = state.strInsAmtPopa1;
    mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
    mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = state.ctrRelpeEngNm.trim();
    mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = state.ctrRelpeEngNm.trim();
    mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
    mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)
    mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "02"; // 당사자구분코드 (03 : 영업고객)
    mrinSbcDsgCtrRelpeInfBcVo.ptyId = state.strInsAmtPopa1;
    mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);
  } else {
    console.log("666", state.sameClaim);
    if (
      strInsAmtPopa2 != "" &&
      (ctrRelpeKorNm2 != "" || ctrRelpeEngNm2 != "")
    ) {
      // 22 : 손해사정업체( 손해사정업체 id가 있고, 손해사정업체영문명/한글명 하나라도 있으면 set)
      mrinSbcDsgCtrRelpeInfBcVo = {};
      mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
      mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
      mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "22";
      mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "손해사정업체";
      mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
      mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = state.strInsAmtPopa1;
      mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
      mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = state.ctrRelpeEngNm.trim();
      mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = state.ctrRelpeEngNm.trim();
      mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
      mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)						// 고객유형코드    (4  : 법인)
      mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "02"; // 당사자구분코드 (03 : 영업고객)
      mrinSbcDsgCtrRelpeInfBcVo.ptyId = state.strInsAmtPopa2;
      mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);
    }
  }

  // 11 : 질권자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "11";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "질권자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = strJilkunCd;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strJilkunNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strJilkunNm.trim();
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = "";
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = "4";
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "01";
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = strJilkunCd;
  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 보험목적물 (t7 ~ t19)
  //		for (int i = 7 ; i <= 19 ; i++) {
  //			String strTmpObjDesc = StringUtils.defaultIfEmpty(request.getParameter("t" + i));
  //
  //			if ("".equals(strTmpObjDesc) == false) {
  //				if ("".equals(strDtlCon) == false) {
  //					strDtlCon += "|";																// 상세내용 구분 flag
  //				}
  //				strDtlCon += strTmpObjDesc;															// 상세내용
  //			}
  //		}

  strDtlCon = state.obj;
  if ("" != strDtlCon) {
    prctrDtlConBcVo.ctrConCd = "G002"; // 계약내용코드 (G002 : 목적물 설명)
    prctrDtlConBcVo.dtlCon = strDtlCon;
    prctrDtlConBcVoList.push(prctrDtlConBcVo);
  }

  if ("" != state.etcCnd) {
    prctrDtlConBcVo = {};
    prctrDtlConBcVo.ctrConCd = "G003"; // 계약내용코드 (G003 : 추가문구)
    prctrDtlConBcVo.dtlCon = state.etcCnd;
    prctrDtlConBcVoList.push(prctrDtlConBcVo);
  }

  prctrDtlConBcVo = {};
  prctrDtlConBcVo.ctrConCd = "G009"; // 계약내용코드 (G009 : 워런티)
  prctrDtlConBcVo.dtlCon = "SANCTION LIMITATION AND EXCLUSION CLAUSE";
  prctrDtlConBcVoList.push(prctrDtlConBcVo);

  gnrMrinFtrnOdVo.ftrnOdNm = strFtrnOdNm;
  gnrMrinFtrnOdVo.trnMnCd = strTrnMnCd;
  gnrMrinFtrnOdVoList.push(gnrMrinFtrnOdVo);

  /*
		cargSbcDsgInfBcVo.ftrnOdNm", "<![CDATA[" + strFtrnOdNm + "]]>");
		cargSbcDsgInfBcVo.trnMnCd1", strTrnMnCd);
		strCargSbcDsgInfBcVo += xmlGen.makeXmlFromMap("cargSbcDsgInfBcVo", cargSbcDsgInfBcVo);
  */

  cargSbcDsgObjInfBcVo.hsCd = strHsCd;
  cargSbcDsgObjInfBcVo.invcVamt = strInvcVamt;
  cargSbcDsgObjInfBcVo.invcVamtCurCd = strInvcVamtCurCd;
  cargSbcDsgObjInfBcVo.itmCd = strItmCd;
  cargSbcDsgObjInfBcVo.itmCdNm = strItmCdNm;
  cargSbcDsgObjInfBcVo.packCd = strPackCd;
  cargSbcDsgObjInfBcVoList.push(cargSbcDsgObjInfBcVo);

  voMap.mrinSbcDsgCovInfBcVo = mrinSbcDsgCovInfBcVoList;
  voMap.mrinSbcDsgCtrRelpeInfBcVo = mrinSbcDsgCtrRelpeInfBcVoList;
  voMap.prctrDtlConBcVo = prctrDtlConBcVoList;
  voMap.gnrMrinFtrnOdVo = gnrMrinFtrnOdVoList;
  voMap.cargSbcDsgObjInfBcVo = cargSbcDsgObjInfBcVoList;

  var result = await axios.transaction("FNGCTNFO0191", voMap);
  if (
    result.msg.standCd == "FNGCM000002" ||
    result.msg.standCd == "FNGCT000104"
  ) {
    //정상일때 + 참고번호 중복일때
    if (state.prctrStatCd == 3) {
      console.log("return");

      var param = {};
      param.inetUsrId = result.body.inetUsrId;
      param.pdCd = result.body.pdCd;
      param.untPdCd = result.body.untPdCd;
      param.prctrNo = result.body.prctrNo;
      param.ctrId = result.body.ctrId;
      param.insStdt = result.body.insStdt;
      param.sbcpDt = result.body.sbcpDt;
      param.inppeCd = sessionUserInfo.userInfo.gita.trim();
      param.cusNo = result.body.cusNo;

      //진계약 체결
      var result2 = await axios.transaction("FNGCTNFO0066", param);
      console.log(result2.msg.standCd);
      if (result2.msg.standCd == "FNGCT200107") {
        swalAlert(
          "인수심사 대상입니다. 승인 요청시 계약 담당자에게 문의바랍니다"
        );
        return;
      } else if (result2.msg.standCd == "FNGCM200015") {
        swalAlert("영수일을 입력하십시오");
        return;
      } else {
        //알림톡
        if (state.sendSmsYn) {
          console.log("알림톡 발송");

          let sendParam = {};
          sendParam.idfNo = sessionUserInfo.slzCusInf.cusNo; //"20022668178" //고객번호
          sendParam.polNo = result2.body.polNo; //"1234567890" //증권번호
          sendParam.charg_nm = sessionUserInfo.userInfo.charg_nm.trim(); //계약자 이름
          await axios.json(
            "/tlmkCmprGddc/sendsbcpInpInqNdPolOtpt.do",
            sendParam
          ); //알림톡 발송
          await swalAlert("알림톡 발송 완료되었습니다.");
        }

        axios.json("/logHisLdg.do", {
          memo: "청약진계약",
          page: window.location.hash,
        });
        swalAlert("가입완료입니다. </br> 계약목록 페이지로 이동됩니다.");
        router.push({ name: "getPolList" });
      }
    } else {
      let efct_pr_format = "";
      efct_pr_format = result.body.ttAplCr
        ? parseFloat(result.body.ttAplCr) * 100
        : 0;
      efct_pr_format = efct_pr_format.toFixed(5);

      var resultMessage = "보험료 산출이 정상처리 되었습니다.</br>";
      resultMessage += "입력하신 청약번호는" + result.body.prctrNo + "</br>";
      resultMessage += "희망이익률은" + result.body.hopPftRt + "% </br>";

      resultMessage += "최종요율은" + efct_pr_format + "</br>";
      resultMessage += "환율은" + result.body.usdExrt + "</br>";
      resultMessage +=
        "원하보험료는" + result.body.ttKwAplPrem + "입니다 </br>";
      resultMessage += "최종 청약가입 하시겠습니까?";
      axios.json("/logHisLdg.do", {
        memo: "청약입력보험료계산",
        page: window.location.hash,
      });
      swalConfirm(resultMessage).then(async (result1) => {
        //예
        if (result1.isConfirmed) {
          var param = {};
          param.inetUsrId = result.body.inetUsrId;
          param.pdCd = result.body.pdCd;
          param.untPdCd = result.body.untPdCd;
          param.prctrNo = result.body.prctrNo;
          param.ctrId = result.body.ctrId;
          param.insStdt = result.body.insStdt;
          param.sbcpDt = result.body.sbcpDt;
          param.inppeCd = sessionUserInfo.userInfo.gita.trim();
          param.cusNo = result.body.cusNo;

          //진계약 체결
          var result2 = await axios.transaction("FNGCTNFO0066", param);
          console.log(result2.msg.standCd);
          if (result2.msg.standCd == "FNGCT200107") {
            swalAlert(
              "인수심사 대상입니다. 승인 요청시 계약 담당자에게 문의바랍니다"
            );
            return;
          } else if (result2.msg.standCd == "FNGCM200015") {
            swalAlert("영수일을 입력하십시오");
            return;
          } else {
            //알림톡
            if (state.sendSmsYn) {
              console.log("알림톡 발송");

              let sendParam = {};

              sendParam.idfNo = sessionUserInfo.slzCusInf.cusNo; //"20022668178" //고객번호
              sendParam.polNo = result2.body.polNo; //"1234567890" //증권번호
              sendParam.charg_nm = sessionUserInfo.userInfo.charg_nm.trim(); //계약자 이름
              await axios.json(
                "/tlmkCmprGddc/sendsbcpInpInqNdPolOtpt.do",
                sendParam
              ); //알림톡 발송

              await swalAlert("알림톡 발송 완료되었습니다.");
            }
            axios.json("/logHisLdg.do", {
              memo: "청약진계약",
              page: window.location.hash,
            });
            swalAlert("가입완료입니다. </br> 계약목록 페이지로 이동됩니다.");

            router.push({ name: "getPolList" });
          }
        } else {
          if (state.sendSmsYn) {
            await swalAlert("청약 완료일때만 알림톡 발송이 가능합니다.");
          }
          swalAlert("저장 완료입니다. </br> 결과조회 페이지로 이동됩니다.");
          router.push({ name: "subsRstList" });
        }
      });
    }
  } else {
    await swalAlert("보험료 산출 오류입니다.");
    return false;
  }
};

//청약 완료
const sbcpComp = async () => {
  if (state.prctrStatCd == 3) {
    save();
  }
  //   var param = {};

  //   param.inetUsrId = state.inetUsrId;
  //   param.pdCd = state.pdCd;
  //   param.untPdCd = state.untPdCd;
  //   param.prctrNo = state.prctrNo;
  //   param.ctrId = state.ctrId;
  //   param.insStdt = state.insStdt;
  //   param.sbcpDt = state.sbcpDt;
  //   param.inppeCd = sessionUserInfo.userInfo.gita.trim();
  //   param.cusNo = state.cusNo;

  //   //진계약 체결
  //   var result2 = await axios.transaction("FNGCTNFO0066", param);
  //   console.log("result2",result2)
  //   if(result2.msg.standCd == 'FNGCT200107'){
  //     swalAlert(result2.msg.standMsg);
  //     return;
  //   }
  //   axios.json('/logHisLdg.do', {memo:"청약진계약" ,page:window.location.hash});
  //   swalAlert("가입완료입니다. </br> 계약목록 페이지로 이동됩니다.");

  //   router.push({ name: "getPolList" });
};

const onSelectEvent = (selectId, data) => {
  if (selectId == "refNo1") {
    state.refNo1 = data.code;
  } else if (selectId == "refNo2") {
    state.refNo2 = data.code;
  } else if (selectId == "plrBnk") {
    state.plrBnk = data.code;
    state.bankNm = data.name;
  } else if (selectId == "ortxtCpno") {
    state.ortxtCpno = data.code;
  } else if (selectId == "trnMnNm") {
    state.trnMnNmCd = data.code;
    retrieveBasCov();
  } else if (selectId == "cur") {
    state.cur = data.code;
  } else if (selectId == "packShCd") {
    state.packShCd = data.code;
    retrieveBasCov();
  } else if (selectId == "insCnd") {
    state.addtlCovCd = data.addtlCovCd;
    state.addtlCovNm = data.addtlCovNm;
  } else if (selectId == "subsInqDiv") {
    state.subsInqDiv = data.code;
  }
};

//팝업닫기
const handlePopupClose = () => {};

const openPopup = (name) => {
  if ("popStplCdCityCode" == name) {
    popStplCdCityCode.value.open();
  } else if ("popArarCdCityCode" == name) {
    popArarCdCityCode.value.open();
  } else if ("popPdtCode" == name) {
    popPdtCode.value.open();
  } else if ("popAddition" == name) {
    var pdCd = "21010";
    if ("KO" == state.ararCd.substring(0, 2)) {
      pdCd = "21000";
    }

    var object = {
      pdCd: pdCd,
      itmCd: state.itmCd,
      vygZone: "",
      basCndCd: state.addtlCovCd,
      dtlsDivCd: state.cargTrnDtlsDivCd,
      acpShCd: state.acpShDivCd,
      ftrnOdDivCd: "01",
      addCov0: "",
      addCov1: "",
      addCov2: "",
      addCov3: "",
      addTrm0: "",
      addTrm1: "",
      addTrm2: "",
      addTrm3: "",
      packCd: state.packShCd,
    };
    popAddition.value.open(object);
  } else if ("popHsCode" == name) {
    popHsCode.value.open();
  }
};

async function retrieveBasCov() {
  let param = {
    pdCd: sessionUserInfo.userInfo.expt_prod_cd,
    itmCd: state.itmCd,
    packCd: state.packShCd,
    ftrnOdDivCd: state.trnMnNmCd,
  };
  let result = await axios.transaction("FNGCTNFO0067", param);

  state.insCndList = result.body.row;
}

init();

async function init() {
  //세션정보 조회
  await load();
  axios.json("/logHisLdg.do", { memo: "청약입력", page: window.location.hash });
  console.log("진입시 sessionUserInfo", sessionUserInfo);

  //팀 분류코드 조회
  const useTeamCodeStore = codeList.useTeamCodeStore();
  var result = await useTeamCodeStore.getTeamCodeList();
  state.temCtgCdList = result.body.enteAdjtMngInfBcVo;

  state.refNo1List = codeList.getRefNo1List;
  state.refNo2List = codeList.getRefNo1List;
  state.plrBnkList = codeList.getBankCodeList;
  state.ortxtCpnoList = codeList.getOrigCntCodeList;
  state.trnMnNmList = codeList.getTrsMethCodeList;
  state.curList = codeList.getCurCodeList;

  state.packShList = codeList.getPackageTypeList;

  //신규 설계시 계약자랑 피보험자 동일 정보
  state.n_ctoren = sessionUserInfo.userInfo.n_ctoren.trim();
  state.n_ctorkr = sessionUserInfo.userInfo.n_ctorkr.trim();
  state.n_ctoren1 = sessionUserInfo.userInfo.n_ctoren.trim();
  state.n_ctorkr1 = sessionUserInfo.userInfo.n_ctorkr.trim();
  state.stockBunho = codeList.getSeachStockBunho;

  state.crpNo = sessionUserInfo.userInfo.corp_no; //법인번호

  state.sbcpCompTrgYn = false;
  state.sbcpCompTrgYn1 = true;

  if (!_.isEmpty(route.query.prctrNo)) {
    let param = {
      prctrNo: route.query.prctrNo,
      prctrStatCd: route.query.prctrStatCd,
    };

    //알림톡 활성화 여부
    state.prctrStatCd = route.query.prctrStatCd;
    if (state.prctrStatCd == "5") {
      state.sendSmsYnflag = false;
    } else if (state.prctrStatCd == "3") {
      state.sendSmsYnflag = true;
    }

    //청약 결과 조회에서 넘오는
    let result = await axios.transaction("FNGCTNFO0074", param);
    state.moveTypeCd = "Y";

    state.inetUsrId = result.body.inetUsrId;
    state.pdCd = result.body.pdCd;
    state.untPdCd = result.body.untPdCd;
    state.prctrNo = result.body.prctrNo;
    state.ctrId = result.body.ctrId;
    state.insStdt = result.body.insStdt;
    state.sbcpDt = result.body.sbcpDt;
    state.cusNo = result.body.cusNo;
    state.hisSeq = result.body.hisSeq;

    let prctrDtlConBcVo = result.body.prctrDtlConBcVo;
    let mrinSbcDsgCovInfBcVo = result.body.mrinSbcDsgCovInfBcVo;
    let cargSbcDsgObjInfBcVo = result.body.cargSbcDsgObjInfBcVo;
    let gnrMrinFtrnOdVo = result.body.gnrMrinFtrnOdVo;

    let mrinSbcDsgCtrRelpeInfBcVo = result.body.mrinSbcDsgCtrRelpeInfBcVo;

    _.each(prctrDtlConBcVo, function (value, idx) {
      let ctrConCd = value.ctrConCd;

      if (ctrConCd == "G002") {
        state.obj = value.dtlCon; //목적물
      } else if (ctrConCd == "G003") {
        state.etcCnd = value.dtlCon; //기타목적
      }
    });

    state.acTermsList = [];

    if (mrinSbcDsgCovInfBcVo.length == null) {
      if (mrinSbcDsgCovInfBcVo.covDivCd == "1") {
        let acTerms = {};
        acTerms.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
        acTerms.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
        acTerms.addTrm1 = mrinSbcDsgCovInfBcVo.covtpAddTrmDiv;
        acTerms.text = mrinSbcDsgCovInfBcVo.covtpAddTrmVal;
        acTerms.addTrmUnt1 = mrinSbcDsgCovInfBcVo.addTrmUnt;
        state.insCndList.push(acTerms);
        var insCnd = document.getElementById("insCnd");
        insCnd.innerText =
          mrinSbcDsgCovInfBcVo.covCd + " / " + mrinSbcDsgCovInfBcVo.covNm;
        state.addtlCovCd = mrinSbcDsgCovInfBcVo.covCd;
        state.addtlCovNm = mrinSbcDsgCovInfBcVo.covNm;
        state.acTermsList = [{}];
      }
    } else {
      _.each(mrinSbcDsgCovInfBcVo, function (value, idx) {
        let covDivCd = value.covDivCd;
        //부가담보

        if (covDivCd == "1") {
          let acTerms = {};
          acTerms.addtlCovCd = value.covCd;
          acTerms.addtlCovNm = value.covNm;
          acTerms.addTrm1 = value.covtpAddTrmDiv;
          acTerms.text = value.covtpAddTrmVal;
          acTerms.addTrmUnt1 = value.addTrmUnt;
          state.insCndList.push(acTerms);
          var insCnd = document.getElementById("insCnd");
          insCnd.innerText = value.covCd + " / " + value.covNm;
          state.addtlCovCd = value.covCd;
          state.addtlCovNm = value.covNm;
        } else if (covDivCd == "2") {
          let acTerms = {};
          acTerms.addtlCovCd = value.covCd;

          acTerms.addtlCovNm = value.covNm;
          acTerms.addTrm1 = value.covtpAddTrmDiv;
          acTerms.text = value.covtpAddTrmVal;
          acTerms.addTrmUnt1 = value.addTrmUnt;
          state.acTermsList.push(acTerms);
        } else if (covDivCd == null) {
          state.acTermsList = [{}];
        }
      });
    }
    //참조번호1 셋팅
    state.refnNoCd1 = result.body.refnNoCd1;
    state.refNo1 = result.body.refnNoDivCd1;

    _.each(state.refNo1List, function (value, idx) {
      if (state.refNo1 == value.code) {
        state.refNoNm1 = value.name;
      }
    });
    var refNo1 = document.getElementById("refNo1");
    refNo1.innerText = state.refNoNm1;

    //참조번호2 셋팅
    state.refnNoCd2 = result.body.refnNoCd2;
    state.refNo2 = result.body.refnNoDivCd2;

    _.each(state.refNo2List, function (value, idx) {
      if (state.refNo2 == value.code) {
        state.refNoNm2 = value.name;
      }
    });
    var refNo2 = document.getElementById("refNo2");
    refNo2.innerText = state.refNoNm2;

    //계약자 , 피보험자 , 질권자 셋팅
    _.each(mrinSbcDsgCtrRelpeInfBcVo, function (value, idx) {
      let ctrPtyRlCd = value.ctrPtyRlCd;

      //질권자 셋팅
      if (ctrPtyRlCd == "02") {
        state.n_ctorkr1 = value.ctrRelpeKorNm.trim();
        state.n_ctoren1 = value.ctrRelpeEngNm.trim();
      } else if (ctrPtyRlCd == "11") {
        state.bankNm = value.ctrRelpeKorNm;
        state.plrBnk = value.ptyId;
      } else if (ctrPtyRlCd == "23") {
        state.bzacNm = value.ctrRelpeEngNm;
        state.bzacId = value.ptyId;
      } else if (ctrPtyRlCd == "22") {
        state.sameClaim = true;
      }
    });

    //출항일 셋팅
    state.tkffDd = result.body.tkffDd;
    state.tkffDdOr = result.body.tkffDd;

    //출발지 셋팅
    state.stplCd = result.body.stplCd;
    state.stplNm = result.body.stplNm;

    //도착지 셋팅
    state.ararCd = result.body.ararCd;
    state.ararNm = result.body.ararNm;

    //원본부수 셋팅
    let polOrtxtNum = result.body.polOrtxtNum;
    state.ortxtCpno = polOrtxtNum;

    _.each(state.ortxtCpnoList, function (value, idx) {
      if (state.ortxtCpno == value.code) {
        state.ortxtCpnoNm = value.name;
      }
    });

    if (gnrMrinFtrnOdVo.length == null) {
      //운송코드 셋팅
      let trnMnCd = gnrMrinFtrnOdVo.trnMnCd;
      state.trnMnNmCd = trnMnCd;

      _.each(state.trnMnNmList, function (value, idx) {
        if (state.trnMnNmCd == value.code) {
          state.trnMnNmCdNm = value.name;
        }
      });

      //운송수단명 셋팅
      let ftrnOdNm = gnrMrinFtrnOdVo.ftrnOdNm;
      state.trnMnNm = ftrnOdNm;
    } else {
      _.each(gnrMrinFtrnOdVo, function (value, idx) {
        let ftrnOdSeq = value.ftrnOdSeq;
        //운송용구
        if (ftrnOdSeq == "1") {
          //운송코드 셋팅
          let trnMnCd = value.trnMnCd;
          state.trnMnNmCd = trnMnCd;

          _.each(state.trnMnNmList, function (value, idx) {
            if (state.trnMnNmCd == value.code) {
              state.trnMnNmCdNm = value.name;
            }
          });
          state.trnMnNm = value.ftrnOdNm;
        }
      });
    }

    // //운송코드 셋팅
    // let trnMnCd = gnrMrinFtrnOdVo.trnMnCd;
    // state.trnMnNmCd = trnMnCd;

    // _.each(state.trnMnNmList, function (value, idx) {
    //   if (state.trnMnNmCd == value.code) {
    //     state.trnMnNmCdNm = value.name;
    //   }
    // });

    //운송수단명 셋팅
    // let ftrnOdNm = gnrMrinFtrnOdVo.ftrnOdNm;
    // state.trnMnNm = ftrnOdNm;

    retrieveBasCov();

    //개시일 셋팅
    state.currentDate = result.body.sbcpDt;
    state.currentDateOr = result.body.sbcpDt;

    //품목코드 셋팅
    let itmCd = cargSbcDsgObjInfBcVo.itmCd;
    state.itmCd = itmCd;

    //H-S CODE 셋팅
    let hsCd = cargSbcDsgObjInfBcVo.hsCd;
    state.hsCd = hsCd;

    //포장 형태 셋팅
    let packCd = cargSbcDsgObjInfBcVo.packCd;
    state.packShCd = packCd;
    _.each(state.packShList, function (value, idx) {
      if (packCd == value.code) {
        state.packShNm = value.name;
      }
    });

    retrieveBasCov();

    //희망 이익률
    let hopPftRt = result.body.hopPftRt;
    state.hop = hopPftRt;

    //입력 금액
    // let ttInvcVamtAmt = result.body.ttInvcVamtAmt;
    // const rawAmt = ttInvcVamtAmt?.replace(/[^0-9]/g, "");
    // const formatted = new Intl.NumberFormat().format(rawAmt);
    // state.ttInvcVamtAmt = rawAmt;
    // state.ttFormatInvcVamtAmt = formatted;
    // //state.ttFormatInvcVamtAmt = ttInvcVamtAmt;
    let ttInvcVamtAmt = result.body.ttInvcVamtAmt;
    //state.ttInvcVamtAmt = ttInvcVamtAmt;
    state.ttFormatInvcVamtAmt = ttInvcVamtAmt; //검색시 소수점 맞추기
    formatAmt();

    //갑판적율
    let odshRt = result.body.odshRt;
    state.odshRt = odshRt;

    //보험가입금액 환종코드 셋팅
    let insVamtCurCd = result.body.insVamtCurCd;
    state.cur = insVamtCurCd;

    // const formatAmt = () => {
    //   const rawAmt = state.ttFormatInvcVamtAmt?.replace(/[^0-9]/g, "");
    //   const formatted = new Intl.NumberFormat().format(rawAmt);
    //   state.ttInvcVamtAmt = rawAmt;
    //   state.ttFormatInvcVamtAmt = formatted;
    // };

    _.each(state.curList, function (value, idx) {
      if (insVamtCurCd == value.code) {
        state.curNm = value.code + "/" + value.name;
      }
    });
    if (state.prctrStatCd == 3) {
      state.sbcpCompTrgYn1 = false;
    } else {
      state.sbcpCompTrgYn = true;
      state.sbcpCompTrgYn1 = false;
    }
  }
}
</script>

<style>
.input-hover {
  border: 1px solid red;
  cursor: pointer;
}
</style>
